import {Box,Typography,Button, CircularProgress, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, IconButton} from "@mui/material"
import MultiInput from "./MultiInput"
import EditorText from "./EditorText"
import { ArrowForward, ArrowLeft, ArrowRight } from "@mui/icons-material"
import { useState } from "react"
import NoticeDialog from "./NoticeDialog"
import ItemView from "./ItemView"

const OpenQuestionView = ({questions,title,time,setIsPaused})=>{
    
const [currentQuestion,setCurrentQuestion] = useState(questions[0])
const [currentIndex,setCurrentIndex] = useState(0)
const [testResponse,setTestResponse] = useState([])
const [response,setResponse] = useState("")
const [submitting,setSubmitting] = useState(false)
const [showConfirm,setShowConfirm] = useState(false)
const [submitted,setSubmitted] = useState(false)
let indx = 0

const handleSelect = async (item)=>{
    try{
        console.log(item)

        const response = {
            ...currentQuestion,
            response:item,
            point:0,
            isCorrect:"pending",
            isSelected:true
        }

        const filterResponse = testResponse?.filter(item=>item?.question === currentQuestion?.question && item?.isSelected)
        const filterResponses = testResponse?.filter(item=>item?.question !== currentQuestion?.question)
        
        if (filterResponse?.length > 0) {
            setTestResponse([...filterResponses,response])
        } else {
            setTestResponse(data=>[...data,response])
        }
    }catch(err){
        console.log(err)
    }
}

const handleSend = async ()=>{
    try{

        console.log(testResponse)
        setShowConfirm(false)

    }catch(err){
        console.log(err)
    }
}

    return (
        <Box style={{width:450}}>
            <Box display="flex" flexDirection="row" justifyContent="space-between" m={1} alignItems="center" width="80%">
                <Typography style={{color:'white'}}>
                    {title}
                </Typography>
                <Typography pl={2} style={{color:"gold",fontSize:13,width:200}}>
                    {time}
                </Typography> 
            </Box>
            <Box width="100%" justifyContent="flex-between" display="flex" flexDirection="row" alignItems="center" m={1}>
                <Typography m={1} style={{color:"gold",fontSize:15,width:200}}>
                    {currentIndex+1}/{questions?.length}
                </Typography> 
                <Box sx={{width:150,textAlign:"left"}}>
                    <IconButton onClick={()=>{
                       if(currentIndex < (questions?.length-1)){
                            
                            setCurrentQuestion(questions[currentIndex+1])
                            setCurrentIndex((dat) => dat + 1)
                            
                            // indx += 1

                            // console.log(indx)

                            const filterResponse = testResponse?.filter(item=>item?.question === currentQuestion?.question)

                            if(filterResponse?.length > 0){
                                setResponse(filterResponse[0]?.response)
                            }else{
                                setResponse("")
                            }
                            
                        }
                    }} sx={{borderRadius:1,backgroundColor:"#fff",m:1}}>
                        <ArrowRight fontSize="small" sx={{color:"#000"}}/>
                    </IconButton>
                    <IconButton onClick={()=>{
                         if(currentIndex > 0){
                            setCurrentQuestion(questions[currentIndex-1])
                            setCurrentIndex((dat) => dat - 1)

                            // indx -= 1

                            // console.log(indx)

                            const filterResponse = testResponse?.filter(item=>item?.question === currentQuestion?.question)  
                            
                            if(filterResponse?.length > 0){
                                setResponse(filterResponse[0]?.response)
                            }else{
                                setResponse("")
                            }
                        }
                    }} sx={{borderRadius:1,backgroundColor:"#fff",m:1}}>
                        <ArrowLeft fontSize="small" sx={{color:"#000"}}/>
                    </IconButton>
                </Box>
            </Box>
            <Box sx={{justifyContent:"flex-start",alignItems:"flex-start",margin:1}}>
                {
                    submitted ?
                        <Typography sx={{fontSize:13,padding:1,whiteSpace:"pre-wrap"}}>
                            We thank you for taking this assessment, we hope you did well, view your score now on your DASHBOARD
                        </Typography>
                    :
                    <Box width="100%">
                        <Typography sx={{fontFamily:"dinofans",fontSize:13,pb:1}}>
                           Question
                        </Typography>
                        <Typography sx={{fontSize:13,padding:1,whiteSpace:"pre-wrap"}}>
                           {currentQuestion?.question}
                        </Typography>
                        {(currentQuestion?.choices?.length > 0) && (
                            <Box justifyContent="center" alignItems="center" width="80%" mt={2} mb={2}>
                                <FormControl >
                                    <FormLabel sx={{fontFamily:"dinofans",fontSize:13,color:"#fff", mb:1}} >Choose :</FormLabel>
                                        <RadioGroup
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            sx={{ml:2}}
                                            value={response}
                                        >
                                            {currentQuestion?.choices?.map((item,index)=>(
                                                    <FormControlLabel key={index}  value={item} control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
                                                        handleSelect(item)
                                                        setResponse(item)
                                                    }} />} label={<Typography sx={{fontSize:12,m:1}}>{item}</Typography>}/>
                                                
                                                ))
                                            }
                                        </RadioGroup>                        
                                </FormControl>
                            </Box> 
                        )}
                    </Box>
                }
                <Button onClick={async (e)=>{
                    e?.preventDefault()
                    setShowConfirm(true)
                }} disabled={submitting} sx={{backgroundColor:"gold",color:"black",marginLeft:1,fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
                    {
                        submitting ? 
                            <CircularProgress size={20} sx={{color:"#fff"}}/>
                        : 
                        (submitted ? "close" : "Send")
                    }
                </Button>
            </Box>
            <NoticeDialog  visible={showConfirm} setVisible={setShowConfirm} handleClick={handleSend}>
                <ItemView title="Question Submission" content="Do you confirm that you have responded to all questions and want to continue ?" />
            </NoticeDialog>
        </Box>
    )	
}


export default OpenQuestionView


